import { env } from '@/helpers/env'

export const config = {
  zendesk: env('VUE_APP_ZENDESK_URL', 'https://ecoco2.zendesk.com'),
}
